import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { StreamAction } from '@cbridge-packages/stream';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeSidebarBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(StreamAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { streamId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (streamId === openedDetailsId) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
